// extracted by mini-css-extract-plugin
export default {"primaryColor":"#354760","white":"#fff","submit":"styles_submit__z37s3","title":"styles_title__H3lvv","form":"styles_form__85q6F"};